/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TestCaseVisibility } from './TestCaseVisibility';
import {
    TestCaseVisibilityFromJSON,
    TestCaseVisibilityFromJSONTyped,
    TestCaseVisibilityToJSON,
    TestCaseVisibilityToJSONTyped,
} from './TestCaseVisibility';

/**
 * 
 * @export
 * @interface TestCaseCreate
 */
export interface TestCaseCreate {
    /**
     * 
     * @type {string}
     * @memberof TestCaseCreate
     */
    problem_id: string;
    /**
     * 
     * @type {string}
     * @memberof TestCaseCreate
     */
    driver_code: string;
    /**
     * 
     * @type {number}
     * @memberof TestCaseCreate
     */
    points: number;
    /**
     * 
     * @type {TestCaseVisibility}
     * @memberof TestCaseCreate
     */
    visibility?: TestCaseVisibility;
}



/**
 * Check if a given object implements the TestCaseCreate interface.
 */
export function instanceOfTestCaseCreate(value: object): value is TestCaseCreate {
    if (!('problem_id' in value) || value['problem_id'] === undefined) return false;
    if (!('driver_code' in value) || value['driver_code'] === undefined) return false;
    if (!('points' in value) || value['points'] === undefined) return false;
    return true;
}

export function TestCaseCreateFromJSON(json: any): TestCaseCreate {
    return TestCaseCreateFromJSONTyped(json, false);
}

export function TestCaseCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestCaseCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'problem_id': json['problem_id'],
        'driver_code': json['driver_code'],
        'points': json['points'],
        'visibility': json['visibility'] == null ? undefined : TestCaseVisibilityFromJSON(json['visibility']),
    };
}

export function TestCaseCreateToJSON(json: any): TestCaseCreate {
    return TestCaseCreateToJSONTyped(json, false);
}

export function TestCaseCreateToJSONTyped(value?: TestCaseCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'problem_id': value['problem_id'],
        'driver_code': value['driver_code'],
        'points': value['points'],
        'visibility': TestCaseVisibilityToJSON(value['visibility']),
    };
}

